// export const encode = (id) => btoa(id.toString()); 
// export const decode = (encoded) => atob(encoded); 

import CryptoJS from "crypto-js";
import { store } from "../../Pages/ReduxStore/store";




// export const encode=(id)=>{
// // const secret = store.getState().auth.token;
// const secret="test"
//  return CryptoJS.AES.encrypt(id.toString(), secret).toString();
// }

// export const decode=(id)=>{
// // const secret = store.getState().auth.token;
// const secret="test"
// const bytes = CryptoJS.AES.decrypt(id, secret);
// return bytes.toString(CryptoJS.enc.Utf8);
// }

export const encode=(id)=>{
    return btoa(id)
}

export const decode=(id)=>{
    return atob(id)
}